import React, { useState, useEffect } from 'react';
import SectionMenuBar, { SectionMenuBarReducer } from '../../../components/section-menu/show-and-hide';
import { questions } from './data/questions';
import { UrlService } from '../../../core/services/UrlService';
import Layout from '../../../components/layout';
import Seo from '../../../components/seo';
import './index.scss';
import Hero from './components/hero';
import $ from 'jquery';
import SelfTestSection from '../../../components/self-test/SelfTestSection';
import SelfTestResult from './components/self-test-result';
import ReferenceListSection from '../../../components/reference-list/ReferenceListSection';
import { references } from './data/references';

const CholesterolSelfTest: React.FC = () => {
    const [state, dispatch] = React.useReducer(SectionMenuBarReducer, {
        anchorId: 'intro',
    });

    const [isInit, setIsInit] = React.useState(true);

    React.useEffect(() => {
        if (isInit) {
            setIsInit(false);
        } else {
            $("html, body").animate({ scrollTop: $('.self-test__content-sections').position()?.top - 150 || 0 }, 600);
        }
    }, [state]);

    return (
        <Layout>
            <Seo title="您有膽固醇超標的風險嗎？" description="您有膽固醇超標的風險嗎？ 1分鐘評估膽固醇超標風險" ogImage={UrlService.getLocalImageUrl('self-test/cholesterol/seo-banner.jpg')}></Seo>

            <div className="self-test selt-test_cholesterol">
                <Hero
                    reducer={[state, dispatch]}
                />
                <section className="self-test__content-sections section1">
                    <div className="container">
                        <h1>膽固醇是甚麼?</h1>
                        <br></br>
                        <div className="self-test__content-container">
                            <div className="self-test__content-text-container">

                                <p>
                                    膽固醇是構成細胞膜、膽汁及各種荷爾蒙的主要成分<sup>4</sup>。人體約7成半膽固醇都是由肝臟製造<sup>5</sup>。
                                    由於膽固醇不能溶於水中，它會在血液中與一種名為「脂蛋白」的物質結合，透過血液循環輸送到身體各部分<sup>4</sup>。
                                </p>
                                <p>
                                    血液中的膽固醇主要分為高密度脂蛋白膽固醇（HDL-C，下稱好膽固醇）和低密度脂蛋白膽固醇（LDL-C，下稱壞膽固醇）。
                                    好膽固醇可將過多的膽固醇運回肝臟，以分解和排走<sup>3</sup>。
                                    相反，壞膽固醇會加速血管內脂肪聚積<sup>4</sup>。當好膽固醇低於理想水平，或壞膽固醇過高，就會令膽固醇沉積於血管內<sup>6</sup>，
                                    使血管變得狹窄，甚至閉塞或破裂，導致<b>中風、冠心病</b>等香港「主要殺手病」<sup>4</sup>。
                                </p>
                            </div>
                            <div className="self-test__content-image-container">
                                <div className="self-test__content-image">
                                    <img src={UrlService.getLocalImageUrl('self-test/cholesterol/content-img-1.png')}></img>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="self-test__content-sections section2">
                    <div className="container">
                        <div className="self-test__content-container">
                            <div className="self-test__content-image-container">
                                <div className="self-test__content-image">
                                    <img src={UrlService.getLocalImageUrl('self-test/cholesterol/content-img-2.png')}></img>
                                </div>
                            </div>
                            <div className="self-test__content-text-container">
                                <p>
                                    一眾因高膽固醇造成的疾病中，最令人聞之色變的可算是中風。中風是最常見的腦血管疾病。
                                    腦部血管可因膽固醇積聚而閉塞或破裂，令腦部失去充份的養料和氧氣，受影響的神經細胞因而壞死，嚴重更會昏迷或死亡<sup>7</sup>。
                                    根據世界衞生組織數據，在2019年，全球超過六百萬人死於中風<sup>8</sup>，嚴重程度絕對不容忽視。
                                    若您在此測試中得到的結果為高，應立即預約醫生，了解自己膽固醇的情況，及患上中風或其他疾病的風險！
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="self-test__content-sections section3">
                    <div className="container self-test__content-container">
                        <div className="self-test__content-image-container">
                            <div className="self-test__content-border">
                                <div className="self-test__content-border-image">
                                    <img src={UrlService.getLocalImageUrl('self-test/cholesterol/content-img-3.png')}></img>
                                </div>
                                <div>

                                    <label>
                                        全球超過400萬人<br />因膽固醇過高而死亡<sup>2</sup>
                                    </label>
                                </div>
                            </div>
                            <div className="self-test__content-border">
                                <div className="self-test__content-border-image">
                                    <img src={UrlService.getLocalImageUrl('self-test/cholesterol/content-img-3.png')}></img>
                                </div>
                                <div>

                                    <label>
                                        近半港人血液內<br />總膽固醇過高<sup>2</sup>
                                    </label>
                                </div>
                            </div>
                            <div className="self-test__content-border">
                                <div className="self-test__content-border-image">
                                    <img src={UrlService.getLocalImageUrl('self-test/cholesterol/content-img-3.png')}></img>
                                </div>
                                <div>
                                    <label>
                                        中風是香港第四號<br />「致命殺手」<sup>9</sup>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <SelfTestSection
                    id='測試'
                    questions={questions}
                    result={SelfTestResult}
                />
                <ReferenceListSection references={references} />
                <section>
                    <div className="container">
                        <p className="mini">
                            本網頁由安進香港支持製作，本問卷及其答案僅供參考，不應作為診療意見，如您存在相關病症，煩請諮詢醫生獲得進一步診斷。
                        </p>
                    </div>
                </section>
            </div>
        </Layout>
    );
};

export default CholesterolSelfTest;
